export const chartdataFunc = (labels, close) => ({
  labels,
  datasets: [
    {
      type: 'line',
      borderColor: '#f9f1f1',
      pointBorderColor: '#f9f1f1',
      pointBackgroundColor: '#f9f1f1',
      pointHoverBackgroundColor: '#f9f1f1',
      pointHoverBorderColor: '#f9f1f1',
      spanGaps: true,
      lineTension: 0,
      label: 'Closing Price',
      data: close,
      backgroundColor: '#2d3734',
    },
  ],
});
export const chartOptions = {
  scales: {
    xAxes: [
      {
        display: true,
        font: {
          size: 8,
        },
        ticks: {
          fontColor: '#f9f1f1',
        },
      },
    ],
    yAxes: [
      {
        display: true,
        position: 'left',

        font: {
          size: 8,
        },
        ticks: {
          fontColor: '#f9f1f1',
        },
        labels: {
          labelMaxWidth: '10px',
          show: true,
        },
      },
    ],
  },

  responsive: true,
  title: {
    display: true,
    text: 'Closing Options Premium',
    fontSize: 12,
    fontColor: 'white',
  },
  legend: {
    display: false,
  },
  tooltips: {
    enabled: true,
    intersect: false,
    mode: 'index',

    backgroundColor: 'darkblue',
  },
  hover: {
    mode: 'index',
    intersect: false,
  },

  mouseLine: {
    color: 'grey',
  },
  responsiveAnimationDuration: 500,
  elements: {
    point: {
      radius: this.customRadius,
      display: true,
    },
  },
  layout: {
    padding: {
      left: 5,
      right: 5,
    },
  },
};

export const plugins = [
  {
    id: 'mouseLine',

    afterEvent: function (chart, e) {
      var chartArea = chart.chartArea;
      if (
        e.x >= chartArea.left &&
        e.y >= chartArea.top &&
        e.x <= chartArea.right &&
        e.y <= chartArea.bottom &&
        chart.active.length
      ) {
        chart.options.mouseLine.x = chart.active[0]._model.x;
      } else {
        chart.options.mouseLine.x = NaN;
      }
    },
    beforeDraw: function () {},

    afterDraw: function (chart) {
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      var x = chart.options.mouseLine.x;

      if (!isNaN(x)) {
        ctx.save();
        ctx.strokeStyle = chart.options.mouseLine.color;
        ctx.lineWidth = 1;
        ctx.moveTo(chart.options.mouseLine.x, chartArea.bottom);
        ctx.lineTo(chart.options.mouseLine.x, chartArea.top);
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];
export const barDataFunc = (weeks, volume) => ({
  labels: weeks,
  datasets: [
    {
      label: 'Volume',
      backgroundColor: '#71B37C',
      borderColor: '#71B37C',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: volume,
    },
  ],
});
export const barDataOIFunc = (weeks, Oi) => ({
  labels: weeks,
  datasets: [
    {
      label: 'OI',
      backgroundColor: '#4271C3',
      borderColor: '#4271C3',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: Oi,
    },
  ],
});

export const barOptionsOI = {
  maintainAspectRatio: false,

  title: {
    display: true,
    text: 'Volume',
    fontSize: 12,
    fontColor: '#A0A0A1',
    position: 'top',
  },

  tooltips: {
    mode: 'label',
  },
  scales: {
    xAxes: [
      {
        ticks: {
          display: false, //this will remove only the label
        },
      },
    ],
  },
  legend: {
    display: false,
  },
  layout: {
    padding: {
      left: 5,
      right: 5,
    },
  },
  elements: {
    line: {
      fill: false,
    },
  },
};
export const barOptionsOITwo = {
  maintainAspectRatio: false,

 
  title: {
    display: true,
    text: 'Open Interest',
    fontSize: 12,
    fontColor: '#A0A0A1',
    position: 'top',
  },

  tooltips: {
    mode: 'label',
  },
  scales: {
    y: {
      ticks: {
        font: {
          size: 8,
        },
      },
    },
    x: {
      ticks: {
        font: {
          size: 8,
        },
      },
    },
  },
  legend: {
    display: false,
  },
  layout: {
    padding: {
      left: 5,
      right: 5,
      top: 5,
      bottom: 5,
    },
  },
  elements: {
    line: {
      fill: false,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/constant.js